export enum QrCodeType {
  Zone = 'Z',
  Parker = 'P',
  Visitor = 'V',
  Device = 'D',
}
